const initialState = {
  isAdmin: false
}

export default function admin(state = initialState, action) {
  switch (action.type) {
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/event_render/reducers/admin.js